// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AutosizeInputController from "./autosize_input_controller"
application.register("autosize-input", AutosizeInputController)

import CalcController from "./calc_controller"
application.register("calc", CalcController)

import CheckBoxTogglerController from "./check_box_toggler_controller"
application.register("check-box-toggler", CheckBoxTogglerController)

import ChkboxesController from "./chkboxes_controller"
application.register("chkboxes", ChkboxesController)

import ChkboxesTableController from "./chkboxes_table_controller"
application.register("chkboxes-table", ChkboxesTableController)

import ClearController from "./clear_controller"
application.register("clear", ClearController)

import CodeBlockController from "./code_block_controller"
application.register("code-block", CodeBlockController)

import CollapseAllController from "./collapse_all_controller"
application.register("collapse-all", CollapseAllController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import CopyInputValueController from "./copy_input_value_controller"
application.register("copy-input-value", CopyInputValueController)

import CopyInputValueWithIndicatorsController from "./copy_input_value_with_indicators_controller"
application.register("copy-input-value-with-indicators", CopyInputValueWithIndicatorsController)

import CustomFileInputController from "./custom_file_input_controller"
application.register("custom-file-input", CustomFileInputController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import DisplayToggleController from "./display_toggle_controller"
application.register("display-toggle", DisplayToggleController)

import DuplicateController from "./duplicate_controller"
application.register("duplicate", DuplicateController)

import ElementController from "./element_controller"
application.register("element", ElementController)

import EmptyFormElementsController from "./empty_form_elements_controller"
application.register("empty-form-elements", EmptyFormElementsController)

import FieldsMappingController from "./fields_mapping_controller"
application.register("fields-mapping", FieldsMappingController)

import FileInputSplitController from "./file_input_split_controller"
application.register("file-input-split", FileInputSplitController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import FlashMessagesController from "./flash_messages_controller"
application.register("flash-messages", FlashMessagesController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import FormElementTogglerController from "./form_element_toggler_controller"
application.register("form-element-toggler", FormElementTogglerController)

import Forms__AutofocusController from "./forms/autofocus_controller"
application.register("forms--autofocus", Forms__AutofocusController)

import Forms__CorrInputsController from "./forms/corr_inputs_controller"
application.register("forms--corr-inputs", Forms__CorrInputsController)

import Forms__DeleteEmptyValuesController from "./forms/delete_empty_values_controller"
application.register("forms--delete-empty-values", Forms__DeleteEmptyValuesController)

import Forms__SpecialCharsController from "./forms/special_chars_controller"
application.register("forms--special-chars", Forms__SpecialCharsController)

import IdPickerController from "./id_picker_controller"
application.register("id-picker", IdPickerController)

import MarkedController from "./marked_controller"
application.register("marked", MarkedController)

import MdEditorController from "./md_editor_controller"
application.register("md-editor", MdEditorController)

import Modal__BasicController from "./modal/basic_controller"
application.register("modal--basic", Modal__BasicController)

import Modal__EditInputController from "./modal/edit_input_controller"
application.register("modal--edit-input", Modal__EditInputController)

import Modal__RecordSubmitController from "./modal/record_submit_controller"
application.register("modal--record-submit", Modal__RecordSubmitController)

import Modal__TurboController from "./modal/turbo_controller"
application.register("modal--turbo", Modal__TurboController)

import NestedForm__BasicController from "./nested_form/basic_controller"
application.register("nested-form--basic", NestedForm__BasicController)

import NestedForm__WithSelectAndGroupsController from "./nested_form/with_select_and_groups_controller"
application.register("nested-form--with-select-and-groups", NestedForm__WithSelectAndGroupsController)

import NestedForm__WithSelectController from "./nested_form/with_select_controller"
application.register("nested-form--with-select", NestedForm__WithSelectController)

import RecordFieldsFormHotkeysController from "./record_fields_form_hotkeys_controller"
application.register("record-fields-form-hotkeys", RecordFieldsFormHotkeysController)

import Select2Controller from "./select2_controller"
application.register("select2", Select2Controller)

import Select2DynamicController from "./select2_dynamic_controller"
application.register("select2-dynamic", Select2DynamicController)

import SelectAdditionalOptionController from "./select_additional_option_controller"
application.register("select-additional-option", SelectAdditionalOptionController)

import SelectOptionsSynchronizerController from "./select_options_synchronizer_controller"
application.register("select-options-synchronizer", SelectOptionsSynchronizerController)

import SelectSyncController from "./select_sync_controller"
application.register("select-sync", SelectSyncController)

import SortElementsController from "./sort_elements_controller"
application.register("sort-elements", SortElementsController)

import SortableFormController from "./sortable_form_controller"
application.register("sortable-form", SortableFormController)

import SyncedParamsController from "./synced_params_controller"
application.register("synced-params", SyncedParamsController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import Tree__BasicController from "./tree/basic_controller"
application.register("tree--basic", Tree__BasicController)

import Tree__WithCheckboxesController from "./tree/with_checkboxes_controller"
application.register("tree--with-checkboxes", Tree__WithCheckboxesController)

import TurboFrameReferrerController from "./turbo_frame_referrer_controller"
application.register("turbo-frame-referrer", TurboFrameReferrerController)

import V__BibSchemaDirsController from "./v/bib_schema_dirs_controller"
application.register("v--bib-schema-dirs", V__BibSchemaDirsController)

import V__BnSearchResultsController from "./v/bn_search_results_controller"
application.register("v--bn-search-results", V__BnSearchResultsController)

import V__IndexValueGroupsController from "./v/index_value_groups_controller"
application.register("v--index-value-groups", V__IndexValueGroupsController)

import ValidatorController from "./validator_controller"
application.register("validator", ValidatorController)
